export default __webpack_public_path__ + "static/media/cv-uploader.ddb5ed01.gif";